import { create } from 'zustand';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';

interface DateRangeStore {
  adManagementFilterDateRange: [string | null, string | null];
  setAdManagementFilterDateRange: (range: [string | null, string | null]) => void;
}

export const useAdManagementFilterDateStore = create<DateRangeStore>((set) => ({
  adManagementFilterDateRange: [null, null], // Default initial value
  setAdManagementFilterDateRange: (range) => set({ adManagementFilterDateRange: range }),
}));

interface FilterDateState {
  dashboardFilterDateRange: DateRange<Dayjs>,
  setDashboardFilterDateRange: (newDateRange: DateRange<Dayjs>) => void,
}

export const useDashboardFilterDateStore = create<FilterDateState>((set) => ({
  dashboardFilterDateRange: [
    localStorage.getItem('from') ? dayjs(localStorage.getItem('from')) : null,
    localStorage.getItem('to') ? dayjs(localStorage.getItem('to')) : null,
  ],
  setDashboardFilterDateRange: (newDateRange) => {
    if (newDateRange) {
      localStorage.setItem('from', newDateRange[0]?.toISOString() || '');
      localStorage.setItem('to', newDateRange[1]?.toISOString() || '');
    } else {
      localStorage.removeItem('from');
      localStorage.removeItem('to');
    }
    set({ dashboardFilterDateRange: newDateRange });
  },
}));
